var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"px-0 pb-2 pt-0",attrs:{"fluid":"","grid-list-sm":""}},[_c('StabilityTypeBar'),_c('v-divider',{staticClass:"py-3"}),_c('StabilityLevelBar'),_c('StabilityOpacityBar',{staticClass:"mt-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }